

































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import LazyImage from '@/components/Elements/LazyImage.vue'

@Component({
  components: {
    LazyImage
  }
})
export default class MultiTable extends Vue {

  @Prop({default: () => []}) multiItems!: {
    id: number;
    locales: string[];
    pdf: string;
    productImage: string;
    title: string;
  }[];
  @Prop({default: false}) productImage!: boolean;

  multiColumnSortingEnabled = false;
  sortingPriority = [];
  currentPage = '';
  showAvailableLocales = true;
  mobileCardBtn = true;
  windowSize = {
    width: 0,
    height: 0
  }

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange(route: {name: string}) {
    const { name } = route;
    this.currentPage = name;
  }


  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  }

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }

  getVideoItem(item) {
    this.$emit('getVideo', item);
  }

  getPdfs(item) {
    this.$emit('getPDF', item);
  }

  seperate(locales) {
    return locales.join(', ')
  }

  handleResize() {
    this.windowSize.width = window.innerWidth;
    this.windowSize.height = window.innerHeight;

    switch (this.currentPage) {
      case 'newproducts':
        this.mobileCardBtn = this.windowSize.width > 767;
        break;
      case 'technical':
        this.mobileCardBtn = this.windowSize.width > 767;
        break;
      default:
        this.mobileCardBtn = true;
    }
  }


}
